import React from "react";
import { Row, Container } from "react-bootstrap";
import { SemesterName, CourseName } from "./styles";
import { StyledTitle } from "../../styles";

const Semester = ({ semester }) => {

  // Filter to just Cody's classes
  semester[1] = semester[1].filter(course => course.instructor === "Cody Dunne")
  return (
    <>
      {semester[1].map((course, index) => (
        <Row key={index}>
          <CourseName>
            <span style={{ color: "#d41b2c" }}>{semester[0] + ""}</span>
            {" — "}
            {course.courseLink ? (
              <a href={course.courseLink}>{course.courseName}</a>
            ) : (
              course.courseName
            )}{" "}
          </CourseName>
        </Row>
      ))}
    </>
  );
};

const Teaching = ({ teaching, people }) => {
  return Object.entries(teaching).map((pair) => (
    <Container key={pair[0]}>
      {pair[1].map((semesters) =>
        Object.entries(semesters).map((semester, index) => (
          <Semester key={index} semester={semester} people={people} />
        ))
      )}
    </Container>
  ));
};

export default Teaching;
